<button *ngIf="isShow" (click)="scrollToTop()" class="back-to-top-btn">
  <span>Voltar ao topo</span> <i class="fa fa-arrow-up"></i>
</button>
